import request from '@/router/axios';

export const getFundForecast = (params) => {
  return request({
    url: '/api/blade-fundForecast/fundForecast/detail',
    method: 'post',
    data: params
  })
}